<template>
  <div>

    <section class="content">
      <div class="box info-box">
        <div class="box-header with-border">
          Filter By
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
              <label for="Branch">Branch</label>
              <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranchWiseRecord(branch)"></v-select>
              
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
      </div>

      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('collection-center-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Collection Center List</h3>
          
          <div class="box-tools">
            <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('collection-center-create')">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>Code </th>
                <th>Name</th>
                <th class="hidden-xs">Branch</th>
                <th class="hidden-xs">Status</th>
                <th>Action</th>

                <!-- <th v-if="$gate.isAdmin()">Status</th>
                <th>Image</th>
                <th v-if="$gate.isAdmin()">Modify</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows.data" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td>{{ row.centerCode }}</td>
                <td>{{ row.name }}</td>
                <td class="hidden-xs">{{ row.branch.name }}</td>
                <td class="hidden-xs">
                  <div v-if="row.status == 'active'">
                    <span class="label label-success">Active</span>
                  </div>
                  <div v-else>
                    <span class="label label-danger">InActive</span>
                  </div>
                </td>
                <td>
                  <div class="btn-group">
                    <button
                      v-if="canAccess('collection-center-view')"
                      type="button"
                      @click="viewModal(row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                    <button
                      v-if="canAccess('collection-center-update')"
                      @click="editModal(row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button
                      v-if="canAccess('collection-center-delete')"
                      @click="deleteModal(row.id)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->

    </section>

        <div class="modal fade" id="newModal">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 v-show="!editMode" class="modal-title">Add New</h4>
                <h4 v-show="editMode" class="modal-title">Update</h4>
              </div>
              <form @submit.prevent="editMode ? updateGroup() : createGroup()">
                <div class="modal-body">
                  <!-- right column -->
                    <!-- general form elements disabled -->
                    <div class="card card-warning">
                      <!-- /.card-header -->
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-6">
                            <!-- text input -->
                            <div class="form-group">
                              <label
                                >Branch Name <span class="red">*</span></label
                              >
                              <select
                                v-model="form.branch_id"
                                name="branch_id"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('branch_id'),
                                }"
                                required
                              >
                                <option
                                  v-if="!form.branch_id"
                                  selected
                                  value=""
                                >
                                  Select Company Branch
                                </option>
                                <option
                                  :value="branch.id"
                                  v-for="branch in branches"
                                  :key="branch.id"
                                >
                                  {{ branch.name }}
                                </option>
                              </select>
                              <has-error
                                :form="form"
                                field="branch_id"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Group Name <span class="red">*</span></label
                              >
                              <input
                                v-model="form.name"
                                type="text"
                                name="name"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('name'),
                                }"
                                required
                              />
                              <has-error :form="form" field="name"></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Group Code <span class="red">*</span></label
                              >
                              <input
                                v-model="form.centerCode"
                                type="text"
                                name="centerCode"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('centerCode'),
                                }"
                                required
                              />
                              <has-error :form="form" field="centerCode"></has-error>
                            </div>
                            <div class="form-group">
                              <label>Address <span class="red">*</span></label>
                              <input
                                v-model="form.address"
                                type="text"
                                name="address"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('address'),
                                }"
                                required
                              />
                              <has-error
                                :form="form"
                                field="address"
                              ></has-error>
                            </div>
                            
                          </div>

                          <div class="col-sm-6">
                            <div class="form-group">
                              <label
                                >City Name <span class="red">*</span></label
                              >
                              <input
                                v-model="form.city"
                                type="text"
                                name="city"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('city'),
                                }"
                                required
                              />
                              <has-error :form="form" field="city"></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Collection Time
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.collectionTime"
                                type="text"
                                name="collectionTime"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'collectionTime'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="collectionTime"
                              ></has-error>
                            </div>

                            <div class="form-group">
                              <label
                                >Select Collection Day
                                <span class="red">*</span></label
                              >
                              <select
                                v-model="form.collectionDay"
                                name="collectionDay"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'collectionDay'
                                  ),
                                }"
                              >
                                <option value="Mon">Monday</option>
                                <option value="Tues">Tuesday</option>
                                <option value="Wed">Wednesday</option>
                                <option value="Thu">Thursday</option>
                                <option value="Fri">Friday</option>
                                <option value="Sat">Saturday</option>
                                <option value="Sun">Sunday</option>
                                <option value="EveryDay">EveryDay</option>
                              </select>
                              <has-error
                                :form="form"
                                field="collectionDay"
                              ></has-error>
                            </div>

                            <div class="form-group">
                              <label
                                >Group Status <span class="red">*</span></label
                              >

                              <div class="form-check">
                                <input
                                  v-model="form.status"
                                  value="active"
                                  id="customRadio1"
                                  class="form-check-input"
                                  :class="{
                                    'is-invalid': form.errors.has('status'),
                                  }"
                                  type="radio"
                                  name="status"
                                />
                                <label
                                  class="form-check-label"
                                  for="customRadio1"
                                  >Active</label
                                >
                                <has-error
                                  :form="form"
                                  field="status"
                                ></has-error>
                              </div>
                              <div class="form-check">
                                <input
                                  v-model="form.status"
                                  value="inActive"
                                  id="customRadio2"
                                  class="form-check-input"
                                  :class="{
                                    'is-invalid': form.errors.has('status'),
                                  }"
                                  type="radio"
                                  name="status"
                                />
                                <label
                                  class="form-check-label"
                                  for="customRadio2"
                                  >InActive</label
                                >
                                <has-error
                                  :form="form"
                                  field="status"
                                ></has-error>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  
                </div>
                <div class="modal-footer text-center">
                  <button
                    v-show="!editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    SAVE GROUP
                  </button>
                  <button
                    v-show="editMode"
                    type="submit"
                    class="btn btn-primary"
                  >
                    UPDATE GROUP
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                  <button type="button" class="btn btn-warning">RESET</button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <div class="modal fade" id="viewModal">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Group Details</h4>
              </div>
              <div class="modal-body">
                <!-- right column -->
                <div class="row">
                  <div class="col-md-6">
                    <!-- Profile Image -->
                    <div class="card card-primary card-outline">
                      <div class="card-body box-profile">
                        <ul class="list-group mb-3">
                          <li class="list-group-item">
                            <b>Branch Name</b>

                            <span v-for="branch in branches" :key="branch.id">
                              <a
                                class="pull-right"
                                v-if="branch.id == form.branch_id"
                                >{{ branch.name }}</a
                              >
                            </span>
                          </li>
                          <li class="list-group-item">
                            <b>Group Name</b>
                            <a class="pull-right">{{ form.name }}</a>
                          </li>
                          <li class="list-group-item" style="padding-bottom: 28px;">
                            <b>Address</b>
                            <a class="pull-right mb-10">{{ form.address }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>City Name</b>
                            <a class="pull-right">{{ form.city }}</a>
                          </li>
                        </ul>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                  <div class="col-md-6">
                    <!-- Profile Image -->
                    <div class="card card-primary card-outline">
                      <div class="card-body box-profile">
                        <ul class="list-group mb-3">
                          <li class="list-group-item">
                            <b>Collection Time</b>
                            <a class="pull-right">{{ form.collectionTime }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Collection Day</b>
                            <a class="pull-right">{{ form.collectionDay }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Status</b>
                            <a
                              class="pull-right"
                              v-if="form.status == 'active'"
                              ><span class="badge badge-success"
                                >Active</span
                              ></a
                            >
                            <a class="pull-right" v-else
                              ><span class="badge badge-danger"
                                >InActive</span
                              ></a
                            >
                          </li>
                        </ul>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                </div>
              </div>
              <div class="modal-footer text-center">
                <button
                  type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >
                  CLOSE
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->


  </div>
</template>

<script>
import { mapState } from 'vuex'
import GetBranch from '../../../mixins/BranchRecords'
export default {
  name: 'Groups',
  computed: {
    ...mapState([
      'user'
    ])
  },
  mixins: [GetBranch],
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      form: new Form({
        id: '',
        center_leader_id: '',
        branch_id: '',
        address: '',
        name: '',
        collectionTime: '',
        city: '',
        status: '',
        centerCode: '',
        collectionDay: '',
        latitude: '',
        longtitude: ''
      }),
      editMode: false,
      branches: [],
      branch: {},
      collectionCenter: {},
      officers: {},
      rows: [],
      withChangeFilter: true
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    getBranchWiseRecord (branch) {
      this.form.branch_id = branch.id
      this.changeFilter()
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
    },
    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
    },
    viewModal (row) {
      this.editMode = false
      this.form.reset()
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .delete('collectioncenter/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    createGroup () {
      this.$axios
        .post('collectioncenter', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Group Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: error.response.data.error })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    updateGroup () {
      this.$axios
        .put('collectioncenter/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Group Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    changeFilter (page = null, pg = null) {
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'collectioncenter'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (c.type !== 'admin') {
        if (c.role.name === 'Manager') {
          pageUrl += `&branch_id=${c.agent_profile.branch_id}`
        } else {
          pageUrl += `&agent_id=${c.id}`
        }
      }
      if (c.type === 'admin') {
        if (this.form.branch_id) {
          pageUrl += `&branch_id=${this.form.branch_id}`
        }
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          console.log(data)
          this.rows = data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    }
  },
  created () {
    // this.loadData()
    this.changeFilter()
    this.getBranch()
    Fire.$on('AfterCreate', () => {
      // this.loadData()
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// GroupMaster.vue?1eb02415